import { FOOTER } from "@/constants/testIds";

const YEAR = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.container}
      className="relative border-t border-white/[0.06] bg-[#050A08] pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start pb-14">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2.5 mb-6">
              <span className="relative w-12 h-12 shrink-0">
                <span
                  aria-hidden
                  className="absolute inset-0 rounded-full blur-md opacity-70"
                  style={{
                    background:
                      "radial-gradient(circle, rgba(0,208,132,0.55), transparent 65%)",
                  }}
                />
                <img
                  src="/logo.png"
                  alt="Dove Infotech logo"
                  className="relative w-full h-full object-contain drop-shadow-[0_0_10px_rgba(0,208,132,0.45)]"
                />
              </span>
              <span className="font-display font-bold text-white text-lg">
                Dove<span className="text-emerald-400">.</span>Infotech
              </span>
            </div>
            <p className="text-white/60 max-w-md text-base leading-relaxed">
              A quiet studio building distinctive software since 2005. Web, mobile,
              cloud, UX, video, and AI — under one senior team.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-white/40 mb-4">
              Contact
            </div>
            <a
              data-testid={FOOTER.emailLink}
              href="mailto:subharuphazra76@gmail.com"
              className="link-underline text-white/85 text-base"
            >
              subharuphazra76@gmail.com
            </a>
            <div className="mt-4 text-white/50 text-sm">Remote · Worldwide</div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-white/40 mb-4">
              Navigate
            </div>
            <ul className="space-y-2 text-white/75 text-sm">
              <li><a className="link-underline" href="#work">Selected work</a></li>
              <li><a className="link-underline" href="#services">Services</a></li>
              <li><a className="link-underline" href="#about">Manifesto</a></li>
              <li><a className="link-underline" href="#contact">Start a project</a></li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="overflow-hidden pt-4 pb-2 border-t border-white/[0.06]">
          <div className="font-display font-black tracking-tighter text-white/[0.06] text-[7vw] leading-[0.85] select-none whitespace-nowrap">
            DOVE INFOTECH
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div>© {YEAR} Dove Infotech Private Limited. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>Crafted since 2005</span>
            <span className="inline-block w-1 h-1 rounded-full bg-emerald-400" />
            <span>Made with obsession</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
